/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./subscriptionHistory.module.css";
import Grid from "@mui/material/Grid";
import { withTranslation, Trans } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { RefreshIcon } from "../../../component/icons/icons";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

const SubscriptionHistory = (props) => {
  return (
    <Grid container spacing={1}>
      <Grid
        item
        size={{
          xs: 12,
        }}
      >
        <div className={classes.subTitleDiv + " " + classes.historyWrapper}>
          <h3>
            <span>{props.t("SUBSCRIPTION_ADJUSTMENT_LIFE_CYCLE")}</span>
            <Tooltip title={props.t("REFRESH_ADJUSTMENT_HISTORY")}>
              <IconButton
                onClick={props.getSubscriptionHistory}
                style={{ float: "right" }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            <span
              onClick={props.getSubscriptionHistory}
              className="text-body"
              style={{
                color: "rgb(245, 131, 32)",
                float: "right",
                paddingTop: 6,
                cursor: "pointer",
                color: props.color,
              }}
            >
              Refresh &nbsp;
            </span>
          </h3>
        </div>
        <TableContainer>
          <Table className={"newGlobalTable"}>
            {props.subscriptionHistory.length > 0 ? (
              <TableHead>
                <TableRow>
                  <TableCell align="left">{props.t("ADJUSTMENT_ID")}</TableCell>
                  <TableCell align="left">{props.t("STATUS")}</TableCell>
                  <TableCell align="left">{props.t("UPDATED_BY")}</TableCell>
                </TableRow>
              </TableHead>
            ) : (
              <></>
            )}
            <TableBody>
              {props.subscriptionHistory.length > 0 ? (
                <>
                  {props.subscriptionHistory.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{props.subAdjustmentId}</TableCell>
                      <TableCell>{item.status}</TableCell>
                      <TableCell>{item.updatedBy}</TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <TableRow>
                  <TableCell>{props.t("NO_DATA_AVAILABLE")}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default withTranslation("translations")(SubscriptionHistory);
